import { Mongo } from "meteor/mongo";
import SimpleSchema from "simpl-schema";

export const InventoryCollection = new Mongo.Collection("inventory");

export const InventorySchema = new SimpleSchema({
    title: { type: String, optional: true },
    type: { type: String, optional: true },
    price: { type: Number, optional: true },
    cost: { type: Number, optional: true },
    vin: { type: String, optional: true },
    make: { type: String, min: 1 },
    model: { type: String, min: 1 },
    year: { type: SimpleSchema.Integer, optional: true },
    mileage: { type: SimpleSchema.Integer, optional: true },
    color: { type: String, optional: true },
    drive: { type: String, optional: true },
    transmission: { type: String, optional: true },
    trim: { type: String, optional: true },
    engine: { type: String, optional: true },
    interiorColor: { type: String, optional: true },
    upholstery: { type: String, optional: true },
    condition: { type: String, optional: true },
    description: { type: String, optional: true },
    created: Date,
    featured: { type: Date, optional: true },
    updated: { type: Date, optional: true },
    deleted: { type: Date, optional: true },
    sold: { type: Date, optional: true },
    photos: { type: Array, optional: true },
    "photos.$": { type: Object, blackbox: true },
    videos: { type: Array, optional: true },
    "videos.$": { type: Object, blackbox: true },
});

function optionalText(value) {
    const cleaned = String(value || "").trim();
    return cleaned.length > 0 ? cleaned : undefined;
}

function optionalNumber(value) {
    if (value === "" || value === null || value === undefined) return undefined;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
}

export function normalizeInventoryDoc(doc) {
    return {
        title: optionalText(doc.title),
        type: optionalText(doc.type),
        price: optionalNumber(doc.price),
        cost: optionalNumber(doc.cost),
        vin: optionalText(doc.vin),
        make: String(doc.make || "").trim(),
        model: String(doc.model || "").trim(),
        year: optionalNumber(doc.year),
        mileage: optionalNumber(doc.mileage),
        color: optionalText(doc.color),
        drive: optionalText(doc.drive),
        transmission: optionalText(doc.transmission),
        trim: optionalText(doc.trim),
        engine: optionalText(doc.engine),
        interiorColor: optionalText(doc.interiorColor),
        upholstery: optionalText(doc.upholstery),
        condition: optionalText(doc.condition),
        description: optionalText(doc.description),
    };
}
